import IconCustomer from "../SvgIcon/IconCustomer";
import IconCalendar from "../SvgIcon/IconCalendar";
import IconTime from "../SvgIcon/IconTime";
import IconLocation from "../SvgIcon/IconLocation";
import CustomerDetailsModal from "../ModalDialog/CustomerDetailsModal";
import { useState } from "react";
import api from "../../services";
import { formatDateOnly } from "../../utils/formats";

export default function UpcomingCustomer({
  userData = [],
  searchQuery = "",
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  // console.log("Fetched scheduled visit details:", userData);  
  // ✅ SAME LOGIC AS CustomerCard
  const handleItemClick = async (item) => {
    setShowModal(true);
    setSelectedItem(null);

    try {
      setLoading(true);

      const visitId = item.id || item.Id;

      if (visitId) {
        const res = await api.get(`visit/${visitId}`);
        const data = Array.isArray(res.data) ? res.data[0] : res.data;
        setSelectedItem(data);
      } else {
        setSelectedItem(item);
      }
    } catch (error) {
      console.error("Error fetching visit details:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Filter
  const filtered = userData.filter((item) => {
    if (!searchQuery) return true;

    const lower = searchQuery.toLowerCase();

    return (
      (item?.UserName ?? "").toLowerCase().includes(lower) ||
      (item?.CustomerName ?? "").toLowerCase().includes(lower) ||
      (item?.captured_Date &&
        new Date(item.captured_Date)
          .toLocaleDateString()
          .toLowerCase()
          .includes(lower)) ||
      (item?.captured_Date &&
        new Date(item.captured_Date)
          .toLocaleTimeString()
          .toLowerCase()
          .includes(lower))
    );
  });

  return (
    <div className="w-100 d-flex flex-wrap gap-3 py-3 upcomingscrollcard">
      {filtered.length === 0 ? (
        <p className="text-muted">No records found.</p>
      ) : (
        filtered.map((item, index) => {
          const uniqueId = item.id || `${item.type}-${index}`;
          const dateValue = item.captured_Date;

          return (
            <div
              key={uniqueId}
              className="list-details scheduled-card bg-white"
              onClick={() => handleItemClick(item)}   // ✅ CLICK ADDED
              style={{ cursor: "pointer" }}           // ✅ UX improvement
            >
              {/* Customer */}
              {item.CustomerName && (
                <div className="custor-name mt-1">
                  <IconCustomer />
                  {item.CustomerName}
                  <span className="type-badge badge-scheduled">
                    Scheduled
                  </span>
                </div>
              )}

              {/* Date */}
              <p>
                <IconCalendar />
                {dateValue
                  ? formatDateOnly(dateValue)
                  : "-"}
              </p>

              {/* Time */}
              <p>
                <IconTime />
                {dateValue
                  ? new Date(dateValue).toLocaleTimeString()
                  : "--"}
              </p>

              {/* Address */}
              {item.Address && (
                <p>
                  <IconLocation width="14" height="14" /> {item.Address} - {item.CurrentLocation}
                </p>
              )}

              {/* User */}
              <p>
                <IconCustomer />
                <strong>{item.UserName || "-"}</strong>
              </p>

              <span className="squence">{index + 1}</span>
            </div>
          );
        })
      )}

      {/* ✅ MODAL WORKS NOW */}
      <CustomerDetailsModal
        show={showModal}
        loading={loading}
        customer={selectedItem}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
}